import React from 'react';
import styled from 'styled-components';

const PopupBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1200;
  
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PopupContainer = styled.div`
  background-color: white;
  color: black;
  padding: 30px;
  position: relative;
  max-height: calc(90vh - 60px);
  display: flex;
  flex-direction: column;
`

const CloseButton = styled.a`
  position: absolute;
  right: 0;
  top: 0;
  background-color: white;
  padding: 10px;
  color: rgba(0, 0, 0, 0.7);
  cursor: pointer;  
`

const Popup = props => {

  let onClose = null;
  if (props.onClose) {
    onClose = <CloseButton href onClick={e => props.onClose()}>X</CloseButton>
  }

  return (
    <PopupBackground onClick={e => props.onClose && props.onClose(e)}>
      <PopupContainer onClick={e => e.stopPropagation()} {...props}>
        {props.children}
        {onClose}
      </PopupContainer>

    </PopupBackground>
  )
}

const PopupHeading = styled.h2`
    margin-bottom: 16px;
    font-size: 20px;
    text-align: center;
    color: black !important;
`

const PopupSubHeading = styled.h2`
    margin-top: 0;
    margin-bottom: 40px;
    font-size: 16px;
    color: #595959;
    text-align: center;    
`

const PopupContent = styled.div`
    margin-bottom: 16px;
    flex-grow: 1;
    flex-shrink: 1;
    overflow: auto;
`

const PopupActions = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    > button, a {
      margin-left: 8px;
    }    
`

export {
  Popup,
  PopupHeading,
  PopupSubHeading,
  PopupActions,
  PopupContent
}

export default Popup;